var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircleFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 14,
  viewBox: "0 0 15 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m6.087 10.728 6.31-6.31-1.144-1.146-5.166 5.185-2.34-2.388L2.603 7.21zM7.5 0q1.918 0 3.55.96a6.64 6.64 0 0 1 2.49 2.49q.96 1.632.96 3.55c0 1.918-.32 2.462-.96 3.55a6.64 6.64 0 0 1-2.49 2.49A6.9 6.9 0 0 1 7.5 14a6.9 6.9 0 0 1-3.55-.96 6.76 6.76 0 0 1-2.49-2.506A6.85 6.85 0 0 1 .5 7q0-1.902.96-3.534A6.9 6.9 0 0 1 3.965.96 6.85 6.85 0 0 1 7.5 0"
})));
export default SvgCheckCircleFilled;